<template>
    <section>
        <div class="aside">
            <div class="aside__left">
                <schedule-search class="search"/>
                <schedule-filter/>
            </div>
            <div class="aside__right">
                <schedule-search class="search"/>
                <schedule-list/>
            </div>
        </div>
    </section>
</template>
<script>
  import ScheduleList from "./ScheduleList";
  import ScheduleFilter from "./ScheduleFilter";
  import ScheduleSearch from "./ScheduleSearch";

  export default {
    name: "schedule",
    components: {ScheduleSearch, ScheduleFilter, ScheduleList},
  }
</script>
<style scoped>
    .aside__left .search {
        display: none;
    }
    @media (max-width: 767px) {
        .aside__left .search {
            display: flex;
        }
        .aside__right .search {
            display: none;
        }
    }
</style>
